import { jsx as _jsx } from "react/jsx-runtime";
import { useParams, useSearchParams } from 'react-router-dom';
import { useFeatureFlag, useFeatureFlagsReady } from '../../../../contexts/featureFlagContext';
import { PricingTab } from '../../PricingTab';
import { PricingWorkspacePage } from '../pricing/PricingWorkspacePage';
export function SourcesPricingPage() {
    const { id } = useParams();
    const ready = useFeatureFlagsReady();
    const enabled = useFeatureFlag('proposal_pricing_v2');
    const [query] = useSearchParams();
    if (!id) return null;
    if (ready && enabled === true && query.get('legacy') !== '1') return /*#__PURE__*/ _jsx(PricingWorkspacePage, {
        projectId: id
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: /*#__PURE__*/ _jsx(PricingTab, {
            projectId: id
        })
    });
}
